<template>
    <div id= "{{game._id ? game._id:game.id}}-middlesmall" style="margin-bottom: 5px;">
      <div id="{{game._id ? game._id:game.id}}-boardsmall" style="width:100%; height:60px;" :class="classboard">
      </div>
    </div>
</template>
<script>
// import Chess from 'chess.js'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
// import Chessground from 'chessground'
// import Garbochess from '../../services/garbochess.js'
// import UserService from '../../services/user'
// import BoardHistory from '../game/boardHistory'
// import toast from 'vue-material-components'
// import Jquery from 'jquery'
// var intervalSmall = []
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
export default {
  name: 'BoardVisorSmall',
  props: {
    game: {
      type: Object
    },
    classboard: {
      type: String
    }
  },
  data () {
    return {
      // chess: new Chess(),
      styleboard: true,
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      user: UserService.user,
      turnSmall: '',
      gameActual: []
    }
  },
  components: {
  },
  mixins: [
    // toast
  ],
  events: {
    move (board) {
      if (this.game._id === board.idBoard) {
        // window.alert(board)
        board.pgn = board.pgn.split('"]').join('"]\n')
        board.pgn = board.pgn.split('{}').join('')
        // this.chess.load_pgn(board.pgn)
        // this.turnSmall = this.chess.turn()
        this.changeStateGame(board.pgn, board.idBoard, board.fen)
      }
    }
  },
  methods: {
    /* deleteComment (pgn) {
      pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      return pgn
    },*/
    prettyPgn (strParam) {
      return strParam
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header, wordBreak = '') {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0) {
          headerObj[key] = value
          if (key === wordBreak) {
            break
          }
        }
      }
      return headerObj
    },
    changeStateGame (pgn, id, fen) {
      pgn = this.prettyPgn(pgn)
      if (document.getElementById(id + '-boardsmall') !== null) {
        var Width = 150// document.getElementById(id + '-middlesmall').clientWidth
        // window.alert(pgn)
        var pos = 'end'
        var start = fen !== undefined ? fen : ''
        // pgn = this.deleteComment(pgn)
        var headers = this.parse_pgn_header(pgn, 'FEN')
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          pos = (fen !== undefined && fen !== 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') ? fen : headers['FEN']
          if (!this.hasBody(pgn)) {
            start = ''
            pos = headers['FEN']
          }
          if (pos === headers['FEN']) {
            start = ''
          }
          start = ''
          pos = headers['FEN']
        }
        if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
          start = ''
          pos = fen
        }
        // window.alert(pos + ' - ' + start + ' - ' + fen)
        if (Width > 0 && fen !== undefined && typeof window.pgnBoard === 'function') {
          window.pgnView({inner: id + '-boardsmall'}, {pgn: pgn, position: pos, startPlay: start, showCoords: false, width: Width})/* , orientation: (this.turnSmall === 'w') ? 'white' : 'black'} */
        } else {
          window.pgnView({inner: id + '-boardsmall'}, {pgn: pgn, position: 'start', showCoords: false, width: Width})
        }
        const comments = document.querySelectorAll('.afterComment')
        comments.forEach((comment) => {
          // Verifica si el texto del comentario contiene el emoji 🎥
          const textResource = comment.textContent.toLowerCase()
          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
            // Añade la clase .highlight-move al elemento padre con clase .move
            comment.closest('.move').classList.add('highlight-move')
          }
        })
      }
    },
    /* prettyPgn (str) {
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*
      // str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O').replace(/(1\-0|0\-1|1\/2\-1\/2)/g, ' * ').replace(/\s\d+/g, ' ').replace(/\$\d+/g, '').replace(/\?/g, '')
      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O')
      // window.alert(str)
      return str
    },*/
    loadDataGame (board, force = false) {
      // var pgn = board.pgn.replace(/"]/g, '"]\n')
      // board.pgn = board.pgn.replace(/'"]/g, '"]\n')
      // board.pgn = board.pgn.replace(/'{}'/g, '')
      board.pgn = this.prettyPgn(board.pgn)
      // board.pgn = board.pgn.replace(/\{( *)\}/gmu, '')
      // board.pgn = board.pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      // board.pgn = board.pgn.replace(/\{\[%clk(\s\S.+?)\]\}/gmu, '')
      // pgn = unescape(board.pgn)
      // this.chess.load_pgn(board.pgn)
      // window.alert(board.pgn)
      // this.turnSmall = this.chess.turn()
      this.changeStateGame(board.pgn, board._id ? board._id : board.id, 'end')
      // this.changeStateGame(board._id, this.chess.fen(), pgn)
    }
  },
  watch: {
    game (newVal, oldVal) {
      // window.alert(newVal)
      if (newVal !== oldVal) {
        this.loadDataGame(newVal, true)
      }
    }
  },
  beforeDestroy () {
    this.game._id = this.game._id ? this.game._id : this.game.id
    // clearInterval(intervalSmall[this.game._id])
  },
  beforeCreate () {
    // console.log('beforeCreate')
  },
  created () {
    setTimeout(function () {
      this.gameActual[this.game._id] = this.game
      this.game._id = this.game._id ? this.game._id : this.game.id
      this.loadDataGame(this.game, true)
    }.bind(this), 600)
  },
  init () {
    // console.log('init')
  },
  updated () {
    // console.log('updated')
  },
  destroyed () {
    // console.log('beforeDestroy')
  }
  /* compiled () {
    // console.log('compiled')
  }*/
}
</script>

<style scoped>
  @import '../../../static/libs/simplechessboard.min.css';
  .userTurn {
    color: white ;
    font-size: large;
  }
  .borderWhite {
    border: 7px solid white;
  }
  .borderBlack {
    border: 7px solid black;
  }
  .check {
    background: radial-gradient(ellipse at center, rgb(123, 255, 0) 40%, rgba(231, 0, 0, 1) 40%, rgba(169, 0, 0, 0) 89%, rgba(158, 0, 0, 0) 100%);
  }
</style>



// WEBPACK FOOTER //
// boardVisorSmall.vue?734c36aa